import React from 'react'
import {Redirect} from 'react-router'


export const PageTemplate: React.FC = ({children}) => {
  const {accessToken} = localStorage
  if (!accessToken) return <Redirect to='/login' />
  return <>{children}</>
}
